import React from 'react';

const ConsultingTopics = () => {
  const codes = {

    'Launch Code': [
      'Idea to Market Fit – Validate your idea and test the demand',
      'Offer & Business Model Design – Create irresistible offers with clear models',
      'First Sale Strategy – Go from zero to your first 100 customers',
    ],
    'Growth Code': [
      'Brand & Authority Positioning – Build a brand that attracts premium clients',
      'Marketing & Funnel Strategy – Plan funnels that convert and scale',
      'Audience Growth Blueprint – Grow your reach organically with purpose',
    ],
    'Scale Code': [
      'Team & Task Delegation – Hire, train, and delegate like a CEO',
      'System & SOP Setup – Build systems to remove yourself from daily ops',
      'Annual Scale Plan – Set yearly goals, KPIs, and execution strategy',
    ],
    'Wealth Code': [
      'Personal Wealth Planning – Design a money map aligned with your goals',
      'Income Stream Strategy – Build multiple active & passive income paths',
      'Cashflow Clarity – Create a simple structure to track and manage money',
    ],
    'Sales Code': [
      'High-Ticket Sales Setup – Build a system to sell premium offers',
      'Sales Script & Objection Playbook – Convert leads with confidence and clarity',
    ],
    'Digital Code': [
      'Digital Product Launch – Turn knowledge into sellable products',
      'Online Course & Webinar Strategy – Educate and convert at scale',
      'Business Automation Setup – Use tools to save time and grow faster',
      'Content Engine System – Create content that attracts daily leads',
    ],
    'Investment Code': [
      'Investor Readiness – Package your business to attract the right investors',
      'Halal Investment Model – Design ethical profit-sharing structures',
      'Wealth Diversification – Protect and grow your wealth long-term',
    ],
    'Career Code': [
      'Skill-to-Business Plan – Turn your expertise into a paid business',
      'Career Clarity – Align your career path with your identity and income goals',
      'Freelancer to Founder Shift – Build a business beyond self-employment',
    ],


  };

  const boxStyle = {
    flex: '1 1 400px', // <-- Base width for the card
    padding: '20px',
    border: '1px solid violet',
    backgroundColor: 'rgba(238, 130, 238, 0.1)',
    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  };


  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', justifyContent: 'space-between' }}>
      {Object.entries(codes).map(([codeTitle, topics]) => (
        <div key={codeTitle} style={boxStyle}>
          <h3 style={{ color: '', marginBottom: '10px' }} className='text-center'>{codeTitle}</h3>
          <ul style={{ paddingLeft: '20px' }}>
            {topics.map((topic, idx) => (
              <li key={idx} style={{ marginBottom: '8px' }}>{topic}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default ConsultingTopics;
